import React from 'react'
import clsx from 'clsx'

// Cube
import { classToFComponent, type FCClassContext } from 'cube-react'

import Sel from './styles-consts'
import Icons from '@/shared/AppIcons'
import GradeRowDetailView from './v-grade-row-detail'

import { GradeRowScope } from '../analise-reacoes.scope'

const styles = {
    gradSubband: {
        backgroundColor: 'rgb(249 250 251)',
        padding: 5
    },
    rowGapHalf: { rowGap: 'var(--spacing-scale-half)' },
    rowGapBase: { rowGap: 'var(--spacing-scale-base)' }
} satisfies Record<string, React.CSSProperties>

export type GradeRowProps = {
    scope: GradeRowScope
}

class GradeRowViewClass implements FCClassContext<GradeRowProps> {
    scope!: GradeRowScope

    onToggleExpandedClick = () => {
        this.scope.expanded = !this.scope.expanded
    }

    render({ scope }: GradeRowProps) {
        this.scope = scope

        const item = scope.data!
        const openCloseIcon = item.mostraDetalheReacoes ? Icons.chevronDownconUrl : Icons.chevronRightconUrl
        const showDetail = scope.expanded && scope.rows.length > 0

        return (
            <>
                <tr className={Sel.gradeRowHead} onClick={this.onToggleExpandedClick}>
                    <td className={Sel.gradeMostLeftColumn}>
                        <button className={Sel.noBgButton}>
                            <img src={openCloseIcon} width="16" height="16" />
                        </button>
                    </td>
                    <td>
                        <div>
                            <div className={clsx(Sel.textSm, Sel.textBreakAll)}>{item.nome}</div>
                            <div className={clsx(Sel.textSm, Sel.textGray500)}>{item.nomeQuimico}</div>
                        </div>
                    </td>
                    <td>
                        <div className={Sel.dFlexH} style={styles.rowGapHalf}>
                            {item.statusNaBula > 0 && (
                                <div className={Sel.gradeConferenciaNaBula}>
                                    <img src={Icons.eyeIconUrl} width="16" height="16" />
                                    <span>{item.statusForaDaBula} na nula</span>
                                </div>
                            )}

                            {item.statusForaDaBula > 0 && (
                                <div className={Sel.gradeConferenciaForaBula}>
                                    <img src={Icons.bookOpenIconUrl} width="16" height="16" />
                                    <span>{item.statusForaDaBula} fora da bula</span>
                                </div>
                            )}

                            {item.statusConferencia > 0 && (
                                <div className={Sel.gradeConferenciaNaoVerificado}>
                                    <img src={Icons.circleAlertIconUrl} width="16" height="16" />
                                    <span>{item.statusConferencia} não verificado(s)</span>
                                </div>
                            )}
                        </div>
                    </td>
                    <td>
                        {item.statusGravidade > 0 && (
                            <div className={clsx(Sel.gradeGravidadeSim, Sel.textXs, Sel.textWeightSemiBold)}>
                                {item.statusGravidade}
                            </div>
                        )}
                        {item.statusGravidade === 0 && <div>&nbsp;</div>}
                    </td>
                    <td>
                        <div className={clsx(Sel.dFlexH, Sel.textUp01)}>
                            <span className={Sel.textNoWrap}>{item.qtdeCasos} casos</span>
                            <span className={Sel.textNoWrap}>{item.qtdeReacoes} reações</span>
                        </div>
                    </td>
                </tr>
                {showDetail && (
                    <tr>
                        <td colSpan={8} style={styles.gradSubband}>
                            <div className={Sel.dFlexH} style={styles.rowGapBase}>
                                <span className={clsx(Sel.textWeightLight, Sel.textUp02, Sel.mt('1'))}>Detalhes das Reações (MedDRA):</span>
                                {scope.rows.map((rowScope) => (
                                    <GradeRowDetailView key={rowScope.uid} scope={rowScope} />
                                ))}
                            </div>
                        </td>
                    </tr>
                )}
            </>
        )
    }
}

export default classToFComponent(GradeRowViewClass)
